export const DRAGONFLY_FULL: readonly (readonly [number, number, number])[] = [
  [13.05, 23.48, 0.61],
  [15.72, 23.59, 0.67],
  [84.31, 23.57, 0.68],
  [86.98, 23.54, 0.61],
  [18.37, 24.43, 0.82],
  [81.61, 24.43, 0.82],
  [10.49, 24.54, 0.68],
  [89.51, 24.53, 0.69],
  [21.2, 25.54, 0.97],
  [78.79, 25.53, 0.96],
  [14.61, 26.36, 0.88],
  [24.33, 26.72, 1.12],
  [75.67, 26.71, 1.12],
  [85.37, 26.36, 0.88],
  [47.07, 27.5, 1.61],
  [52.94, 27.5, 1.61],
  [11.82, 27.18, 0.66],
  [17.42, 27.58, 1.02],
  [82.57, 27.57, 1.03],
  [88.16, 27.18, 0.66],
  [27.53, 28.49, 1.17],
  [72.46, 28.49, 1.17],
  [20.66, 28.86, 1.34],
  [79.32, 28.87, 1.34],
  [30.79, 30.06, 1.15],
  [69.23, 30.06, 1.17],
  [13.64, 29.97, 0.78],
  [23.95, 30.67, 1.51],
  [50, 31.7, 2.57],
  [76.06, 30.65, 1.51],
  [86.38, 29.95, 0.78],
  [17.57, 31.11, 0.92],
  [82.41, 31.12, 0.9],
  [34.01, 31.95, 1.31],
  [66.01, 31.92, 1.3],
  [27.5, 32.84, 1.88],
  [72.51, 32.86, 1.89],
  [20.34, 32.55, 0.97],
  [79.66, 32.55, 0.98],
  [15.61, 33.13, 0.76],
  [37.2, 33.67, 1.26],
  [62.83, 33.68, 1.25],
  [84.4, 33.16, 0.74],
  [22.96, 34.34, 1.09],
  [31.56, 35.21, 1.98],
  [68.45, 35.22, 1.97],
  [77.04, 34.35, 1.09],
  [40.58, 35.63, 1.57],
  [59.42, 35.63, 1.58],
  [18.38, 35.37, 0.78],
  [81.6, 35.39, 0.77],
  [50, 37.52, 2.78],
  [25.74, 36.5, 1.03],
  [74.25, 36.49, 1.02],
  [35.97, 37.82, 2.17],
  [64.03, 37.81, 2.17],
  [44.07, 37.09, 1.2],
  [55.94, 37.07, 1.21],
  [21.38, 37.37, 0.83],
  [78.64, 37.37, 0.84],
  [28.66, 38.43, 1.12],
  [71.34, 38.44, 1.13],
  [24.37, 38.82, 0.74],
  [40.9, 40.26, 2.28],
  [59.09, 40.25, 2.28],
  [75.67, 38.8, 0.73],
  [45.58, 40.11, 1.42],
  [54.43, 40.11, 1.42],
  [32.06, 40.07, 1.17],
  [67.96, 40.09, 1.18],
  [36.08, 41.57, 1.01],
  [63.92, 41.58, 1],
  [50, 43.47, 2.66],
  [44.31, 45.17, 1.19],
  [55.69, 45.17, 1.21],
  [40.72, 46.02, 1.46],
  [59.3, 46.01, 1.45],
  [33.33, 46.05, 1.1],
  [66.66, 46.06, 1.09],
  [29.75, 46.73, 1.39],
  [36.92, 46.86, 1.5],
  [63.09, 46.85, 1.51],
  [70.26, 46.75, 1.37],
  [23.33, 46.56, 0.95],
  [26.36, 46.63, 1.07],
  [73.62, 46.63, 1.07],
  [76.72, 46.55, 0.94],
  [20.53, 46.71, 0.79],
  [79.48, 46.74, 0.79],
  [17.84, 47.07, 0.69],
  [82.14, 47.07, 0.69],
  [50, 49.02, 2.39],
  [42.76, 48.22, 1.03],
  [15.36, 47.9, 0.65],
  [57.22, 48.24, 1.02],
  [84.66, 47.91, 0.65],
  [33.55, 49.61, 1.95],
  [66.46, 49.62, 1.93],
  [39.55, 49.86, 1.57],
  [60.44, 49.85, 1.58],
  [22.07, 49.4, 1.05],
  [25.34, 49.65, 1.22],
  [74.67, 49.66, 1.23],
  [77.91, 49.4, 1.05],
  [19.03, 49.48, 0.93],
  [80.98, 49.48, 0.94],
  [13.1, 49.56, 0.62],
  [29.2, 50.64, 1.63],
  [70.79, 50.65, 1.64],
  [86.91, 49.55, 0.61],
  [15.65, 50.98, 0.71],
  [84.38, 51, 0.7],
  [36.94, 52.18, 1.17],
  [63.07, 52.15, 1.17],
  [22.37, 52.38, 0.93],
  [77.63, 52.38, 0.93],
  [26.31, 52.78, 0.97],
  [50, 53.94, 2.08],
  [73.72, 52.8, 0.97],
  [17.89, 52.77, 0.7],
  [82.1, 52.79, 0.69],
  [34.2, 53.55, 0.91],
  [65.82, 53.55, 0.93],
  [20.39, 54.32, 0.7],
  [31.45, 54.39, 0.89],
  [68.54, 54.38, 0.88],
  [79.59, 54.32, 0.7],
  [23.41, 55.25, 0.66],
  [28.85, 55.27, 0.69],
  [71.19, 55.26, 0.72],
  [76.63, 55.26, 0.67],
  [26.15, 55.52, 0.69],
  [73.89, 55.53, 0.68],
  [50, 58.34, 1.83],
  [50, 62.33, 1.6],
  [50, 65.87, 1.32],
  [50, 68.98, 1.13],
  [49.99, 71.78, 0.94],
  [50.01, 74.3, 0.83],
  [49.99, 76.52, 0.62],
];

export const DRAGONFLY_REDUCED: readonly (readonly [number, number, number])[] =
  [
    [13.05, 23.48, 2.49],
    [15.72, 23.59, 2.49],
    [84.31, 23.57, 2.49],
    [86.98, 23.54, 2.49],
    [18.37, 24.43, 2.49],
    [81.61, 24.43, 2.49],
    [10.49, 24.54, 2.49],
    [89.51, 24.53, 2.49],
    [21.2, 25.54, 2.49],
    [78.79, 25.53, 2.49],
    [14.61, 26.36, 2.49],
    [24.33, 26.72, 2.49],
    [75.67, 26.71, 2.49],
    [85.37, 26.36, 2.49],
    [47.07, 27.5, 3.38],
    [52.94, 27.5, 3.37],
    [11.82, 27.18, 2.49],
    [17.42, 27.58, 2.49],
    [82.57, 27.57, 2.49],
    [88.16, 27.18, 2.49],
    [27.53, 28.49, 2.49],
    [72.46, 28.49, 2.49],
    [20.66, 28.86, 2.82],
    [79.32, 28.87, 2.81],
    [30.79, 30.06, 2.49],
    [69.23, 30.06, 2.49],
    [13.64, 29.97, 2.49],
    [23.95, 30.67, 3.16],
    [50, 31.7, 5.41],
    [76.06, 30.65, 3.17],
    [86.38, 29.95, 2.49],
    [17.57, 31.11, 2.49],
    [82.41, 31.12, 2.49],
    [34.01, 31.95, 2.75],
    [66.01, 31.92, 2.73],
    [27.5, 32.84, 3.95],
    [72.51, 32.86, 3.96],
    [20.34, 32.55, 2.49],
    [79.66, 32.55, 2.49],
    [15.61, 33.13, 2.49],
    [37.2, 33.67, 2.65],
    [62.83, 33.68, 2.63],
    [84.4, 33.16, 2.49],
    [22.96, 34.34, 2.49],
    [31.56, 35.21, 4.17],
    [68.45, 35.22, 4.15],
    [77.04, 34.35, 2.49],
    [40.58, 35.63, 3.3],
    [59.42, 35.63, 3.31],
    [18.38, 35.37, 2.49],
    [81.6, 35.39, 2.49],
    [50, 37.52, 5.84],
    [25.74, 36.5, 2.49],
    [74.25, 36.49, 2.49],
    [35.97, 37.82, 4.56],
    [64.03, 37.81, 4.55],
    [44.07, 37.09, 2.52],
    [55.94, 37.07, 2.53],
    [21.38, 37.37, 2.49],
    [78.64, 37.37, 2.49],
    [28.66, 38.43, 2.49],
    [71.34, 38.44, 2.49],
    [24.37, 38.82, 2.49],
    [40.9, 40.26, 4.79],
    [59.09, 40.25, 4.8],
    [75.67, 38.8, 2.49],
    [45.58, 40.11, 2.98],
    [54.43, 40.11, 2.99],
    [32.06, 40.07, 2.49],
    [67.96, 40.09, 2.49],
    [36.08, 41.57, 2.49],
    [63.92, 41.58, 2.49],
    [50, 43.47, 5.59],
    [44.31, 45.17, 2.51],
    [55.69, 45.17, 2.53],
    [40.72, 46.02, 3.06],
    [59.3, 46.01, 3.04],
    [33.33, 46.05, 2.49],
    [66.66, 46.06, 2.49],
    [29.75, 46.73, 2.91],
    [36.92, 46.86, 3.15],
    [63.09, 46.85, 3.16],
    [70.26, 46.75, 2.88],
    [23.33, 46.56, 2.49],
    [26.36, 46.63, 2.49],
    [73.62, 46.63, 2.49],
    [76.72, 46.55, 2.49],
    [20.53, 46.71, 2.49],
    [79.48, 46.74, 2.49],
    [17.84, 47.07, 2.49],
    [82.14, 47.07, 2.49],
    [50, 49.02, 5.02],
    [42.76, 48.22, 2.49],
    [15.36, 47.9, 2.49],
    [57.22, 48.24, 2.49],
    [84.66, 47.91, 2.49],
    [33.55, 49.61, 4.09],
    [66.46, 49.62, 4.06],
    [39.55, 49.86, 3.29],
    [60.44, 49.85, 3.31],
    [22.07, 49.4, 2.49],
    [25.34, 49.65, 2.57],
    [74.67, 49.66, 2.58],
    [77.91, 49.4, 2.49],
    [19.03, 49.48, 2.49],
    [80.98, 49.48, 2.49],
    [13.1, 49.56, 2.49],
    [29.2, 50.64, 3.43],
    [70.79, 50.65, 3.44],
    [86.91, 49.55, 2.49],
    [15.65, 50.98, 2.49],
    [84.38, 51, 2.49],
    [36.94, 52.18, 2.49],
    [63.07, 52.15, 2.49],
    [22.37, 52.38, 2.49],
    [77.63, 52.38, 2.49],
    [26.31, 52.78, 2.49],
    [50, 53.94, 4.36],
    [73.72, 52.8, 2.49],
    [17.89, 52.77, 2.49],
    [82.1, 52.79, 2.49],
    [34.2, 53.55, 2.49],
    [65.82, 53.55, 2.49],
    [20.39, 54.32, 2.49],
    [31.45, 54.39, 2.49],
    [68.54, 54.38, 2.49],
    [79.59, 54.32, 2.49],
    [23.41, 55.25, 2.49],
    [28.85, 55.27, 2.49],
    [71.19, 55.26, 2.49],
    [76.63, 55.26, 2.49],
    [26.15, 55.52, 2.49],
    [73.89, 55.53, 2.49],
    [50, 58.34, 3.83],
    [50, 62.33, 3.36],
    [50, 65.87, 2.76],
    [50, 68.98, 2.49],
    [49.99, 71.78, 2.49],
    [50.01, 74.3, 2.49],
    [49.99, 76.52, 2.49],
  ];
